var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.588 12.253-3.785 1.959v-3.918l3.785 1.959z",
    fill: "#FFD300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.75 12.5c0 6.904-5.596 12.5-12.5 12.5S.75 19.404.75 12.5 6.346 0 13.25 0s12.5 5.596 12.5 12.5zm-6.087 4.206c.374-.374.585-.882.587-1.412V9.706a2.006 2.006 0 0 0-2-2h-10a2.006 2.006 0 0 0-2 2v5.588a2.006 2.006 0 0 0 2 2h10a2.006 2.006 0 0 0 1.413-.588z",
    fill: "#FFD300"
  })));
};
export default SvgYoutube;